module.exports = __webpack_public_path__ + "img/prod_info_ybzdywjg.ca6b75a6.png";